import React, { createContext } from 'react';

import useDialog from '../hooks/useDialog';
import useLoading from '../hooks/useLoading';
import useSnackbar from '../hooks/useSnackbar';
import DialogPopup from './DialogPopup';
import Loading from './Loading';
import SnackBar from './SnackBar';

export type UxContextValue = ReturnType<typeof useSnackbar> & ReturnType<typeof useLoading> & ReturnType<typeof useDialog>;

export const UxContext = createContext<UxContextValue | undefined>(undefined);

const UxProvider = ({ children }: { children: React.ReactNode }) => (
    <UxContext.Provider value={{ ...useSnackbar(), ...useLoading(), ...useDialog() }}>
        <SnackBar />
        <Loading />
        <DialogPopup />
        {children}
    </UxContext.Provider>
);

export { UxProvider };
